module.exports = __webpack_public_path__ + "img/Rachel Ramsay.6662ecf4.png";